import { api } from 'utils/api'

export const changePasswordApi = (data: {
  oldPassword: string
  password: string
}) => api.post<{ message: string }>('user/password', data)
